module.exports = __webpack_public_path__ + "img/legacy_1.f74750c6.jpg";